import axios from 'axios'

import { LOGIN, LOGOUT, SET_AUTHDATA } from '../mutation-types'
import Storage from '@/services/storage'

var authData = Storage.getItem('authData')
var fields = Storage.getItem('fields')

// 该模块的初始状态
const state = {
  logined: Storage.getItem('logined'),
  token: Storage.getItem('token'),
  name: Storage.getItem('userName'),
  userId: Storage.getItem('userId'),
  authData: authData ? authData.split(',') : [],
  fields: fields ? fields.split(',') : []
}

axios.defaults.headers.common['X-Access-Token'] = state.token

// 相关的 mutations
const mutations = {
  [LOGIN] (state, user) {
    state.logined = true
    state.token = user.token
    state.name = user.name
    state.userId = user.id
    state.fields = user.fields

    Storage.setItem('logined', true)
    Storage.setItem('token', user.token)
    Storage.setItem('userName', user.name)
    Storage.setItem('userId', user.id)
    Storage.setItem('fields', user.fields)

    axios.defaults.headers.common['X-Access-Token'] = state.token
  },
  [LOGOUT] (state) {
    state.logined = false
    state.token = null
    state.userType = null
    state.userId = null
    state.fields = null

    Storage.setItem('logined', false)
    Storage.setItem('token', null)
    Storage.setItem('userName', null)
    Storage.setItem('userId', null)
    Storage.setItem('fields', null)
  },
  [SET_AUTHDATA] (state, authData) {
    state.authData = authData
    Storage.setItem('authData', authData)
  }
}

const getters = {
  authData: state => {
    return state.authData
  },
  pmpRecordFields: state => {
    return state.fields
  }
}

export default {
  state,
  getters,
  mutations
}
